
import { Cropper as AdvancedCropper } from "vue-advanced-cropper"
import Button from "@/components/base/Button"
import Stencil from "@/components/base/cropper/Stencil"

import { mdiCrop, mdiCropRotate, mdiCancel } from "@mdi/js"
import "vue-advanced-cropper/dist/style.css"

export default {
    name: "Cropper",
    components: {
        AdvancedCropper,
        Button,
    },
    model: {
        prop: "image",
        event: "change",
    },
    emits: ["change", "cancel"],
    icons: {
        mdiCrop,
        mdiCropRotate,
        mdiCancel,
    },
    props: {
        image: {
            type: String,
            required: true,
        },
        round: {
            type: Boolean,
            default: false,
        },
        /** Aspect Ratio is always 1.0 in Avatar mode */
        aspectRatio: {
            type: Number,
            default: 1,
        },
    },
    data: () => ({
        hideButton: false,
    }),
    computed: {
        stencilProps() {
            return {
                aspectRatio: this.round ? 1 : this.aspectRatio,
                moveHandler: (e) => this.onChange(e),
                round: this.round,
            }
        },
        stencil() {
            return Stencil
        },
    },
    methods: {
        cropImage() {
            const el = this.$refs.cropper
            if (el) {
                let { canvas } = this.$refs.cropper.getResult()
                if (!canvas) return
                const result = canvas.toDataURL("image/jpeg")
                this.$emit("change", result)
                return result
            }
        },
        rotateImage() {
            const el = this.$refs.cropper
            if (el) {
                el.rotate(90)
            }
        },
        onChange(value) {
            if (this.hideButton !== value) {
                this.hideButton = value
            }
        },
        cancelCrop() {
            this.$emit("cancel")
        },
    },
}
